let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5g5mr")).then(() => parcelRequire('izp1J'));